// Split dropdown showing available Gitcha markets above Google Places results
import { formatAddressForDisplay } from "../../helpers/common";

const LocationSearchDropdown = ({
  availableMarkets = [],
  placesResults = [],
  onAvailableMarketClick,
  onPlacesResultClick,
  className = "",
}) => {
  const hasAvailableMarkets = availableMarkets.length > 0;
  const hasPlacesResults = placesResults.length > 0;

  if (!hasAvailableMarkets && !hasPlacesResults) return null;

  return (
    <div className={`location-result-wrap location-search-dropdown ${className}`}>
      {hasAvailableMarkets && (
        <div className="location-search-dropdown__section">
          <div className="location-search-dropdown__header">
            Featured Markets
          </div>
          <ul>
            {availableMarkets.map((market, i) => (
              <li key={`market-${i}`} className="location-search-dropdown__item">
                <a
                  role="button"
                  href={void 0}
                  onClick={() => onAvailableMarketClick(market)}
                >
                  <span>{market.displayName}</span>
                  {market.isFeatured && (
                    <span className="location-search-dropdown__badge">
                      Featured
                    </span>
                  )}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {hasAvailableMarkets && hasPlacesResults && (
        <div className="location-search-dropdown__divider" />
      )}

      {hasPlacesResults && (
        <div className="location-search-dropdown__section">
          {hasAvailableMarkets && (
            <div className="location-search-dropdown__header">
              All Locations
            </div>
          )}
          <ul>
            {placesResults.map((item, i) => (
              <li key={`places-${i}`}>
                <a
                  role="button"
                  href={void 0}
                  onClick={() => onPlacesResultClick(item)}
                >
                  {formatAddressForDisplay(
                    _.get(item, "formatted_address", "")
                  )}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LocationSearchDropdown;
